import { render, staticRenderFns } from "./companyManger.vue?vue&type=template&id=dd4177a2&scoped=true&"
import script from "./companyManger.vue?vue&type=script&lang=js&"
export * from "./companyManger.vue?vue&type=script&lang=js&"
import style0 from "./companyManger.vue?vue&type=style&index=0&id=dd4177a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4177a2",
  null
  
)

export default component.exports